// Module
var code = `<bds-tooltip position="top-center" tooltip-text="{{\$ctrl.tooltipText}}"> <bds-chip-tag class="hydrated statusTag" color="disabled"> <div class="flex items-center"> <span class="card--chip-status bp-badge--no-text mr2 bp-fs-8" ng-class="'{{\$ctrl.statusStyle}}'"></span> {{\$ctrl.label}} </div> </bds-chip-tag> </bds-tooltip>`;
// Exports
module.exports = code;